<template>
  <generic-modal :title="$t('renap request')" ref="generic_modal">
    <form>
      <div class="columns">
        <div class="column">
          <div class="field">
            <generic-dropdown
              :title="$t('profile')"
              :placeholder="$t('profile')"
              url="/renap/profile/catalog"
              name_field="name"
              value_field="profile_id"
              @selected="set_profile"
              ref="profile_dropdown"
              :is_multiple="false"
            />
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("dpi") }}</label>
            <div class="control">
              <input type="text" class="input" v-model="meta.dpi" />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("first name") }}</label>
            <div class="control">
              <input type="text" class="input" v-model="meta.first_name" />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("second name") }}</label>
            <div class="control">
              <input type="text" class="input" v-model="meta.second_name" />
            </div>
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("first surname") }}</label>
            <div class="control">
              <input type="text" class="input" v-model="meta.first_surname" />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("second surname") }}</label>
            <div class="control">
              <input type="text" class="input" v-model="meta.second_surname" />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("birth date") }}</label>
            <div class="control">
              <input type="date" class="input" v-model="meta.birth_date" />
            </div>
          </div>
        </div>
      </div>
    </form>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-search"></i>
        </span>
        <span>{{ $t("search") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import { put, post, generate_error_message_text, get } from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";

export default {
  name: "RenapRequestModal",
  components: {
    GenericModal,
    GenericDropdown,
  },
  props: {},
  data() {
    return {
      meta: {},
      error: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return !v.meta.profile_id;
    },
  },
  methods: {
    close_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.close_modal();
    },
    show_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.show_modal();
    },
    save() {
      let v = this;
      let data = { ...v.meta };
      put("/renap/request", data)
        .then(() => {
          // console.log("request created");
          v.$emit("success");
          v.close_modal();
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        dpi: "",
      };
      v.error = "";
      v.$refs.profile_dropdown.clear();
    },
    set_profile(profile) {
      if (profile) {
        let v = this;
        v.meta.profile_id = profile.profile_id;
      }
    },
  },
  mounted() {},
  created() {},
  watch: {},
};
</script>
<style></style>
